import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { MemberMessageNotificationService } from '@app/core/services/MemberMessageNotificationService';
import { messageTimestamp } from '@app/core/services/MemberMessageService';

@Component({
  selector: 'anms-member-message-preview', standalone: true, imports: [SharedModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <article class="preview" *ngIf="notifications.state$ | async as state">
      <header><h2>Meddelanden</h2><a mat-button routerLink="/messages">Visa alla<span *ngIf="state.UnreadCount"> ({{state.UnreadCount}} olästa)</span></a></header>
      <div *ngIf="state.Loading" role="status">Hämtar meddelanden …</div>
      <div *ngIf="state.Error" role="alert"><p>Meddelandena kunde inte uppdateras.</p><button mat-button (click)="notifications.refresh()">Försök igen</button></div>
      <ul *ngIf="!state.Loading"><li *ngFor="let message of state.Items">
        <a [routerLink]="['/messages', message.Id]" [class.unread]="!message.IsRead">
          <mat-icon aria-hidden="true">{{message.IsRead ? 'drafts' : 'mark_email_unread'}}</mat-icon>
          <span><strong>{{message.Title}}</strong><small>{{!message.IsRead ? 'Oläst · ' : ''}}{{timestamp(message.OccurredAtUtc)}}</small></span>
          <mat-icon aria-hidden="true">chevron_right</mat-icon>
        </a>
      </li></ul>
      <p *ngIf="!state.Loading && !state.Error && !state.Items.length">Här visas personliga uppdateringar och allmän information.</p>
    </article>`,
  styles: [`:host{display:block}.preview{padding:24px;background:#fff;border:1px solid #e8ebf2;border-radius:10px;box-shadow:0 3px 10px rgba(20,36,63,.06)}
    header{display:flex;align-items:center;justify-content:space-between;gap:8px;flex-wrap:wrap}h2{font-size:17px;margin:0}p,span{font-size:13px}
    ul{list-style:none;padding:0;margin:12px 0 0}li+li{border-top:1px solid #eef0f5}li a{display:flex;align-items:center;gap:12px;padding:16px 0;text-decoration:none;color:#111827;min-height:48px}
    li span{flex:1;min-width:0}strong{display:block;font-weight:500;overflow-wrap:anywhere}.unread strong{font-weight:700}small{display:block;color:#59657b;margin-top:5px;font-size:12px}mat-icon{flex:0 0 24px}`]
})
export class MemberMessagePreviewComponent {
  readonly timestamp = messageTimestamp;
  constructor(public notifications: MemberMessageNotificationService) {}
}
